/**
 * For a multi-language application, you can
 * specify the languages you want to use here.
 */

import en from './en';
import no from './no';
import vi from './vi';


export default {
  en: {
    ...en,
  },
  no: {
    ...no,
  },
  vi: {
    ...vi,
  },
};



// WEBPACK FOOTER //
// ./src/locale/index.js